import { render, staticRenderFns } from "./SiteNotificationTypeSelect.vue?vue&type=template&id=080451ad&"
import script from "./SiteNotificationTypeSelect.vue?vue&type=script&lang=js&"
export * from "./SiteNotificationTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports